import { render, staticRenderFns } from "./CreateMerchantRewards.vue?vue&type=template&id=33bcfe80&"
import script from "./CreateMerchantRewards.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports